<div class="container-preguntas">
    <div class="barra-progreso">
        <div class="paso" *ngFor="let paso of barraProgreso; let i = index" [class.completado]="i + 1 <= pasoActual">
        </div>
    </div>

    <div class="preguntas">
        <ng-container *ngIf="isCurrentStep(1)">
            <p class="pregunta">{{'preguntas-colectivo.pregunta.tratado-hospital' | translate}}</p>
            <div class="form-control">
                <div class="si-no">
                    <div class="box" [class.selected]="hospital === true" (click)="toggleHospital(true)">
                        {{'preguntas-colectivo.respuesta.si' | translate}}</div>
                    <div class="box" [class.selected]="hospital === false" (click)="toggleHospital(false)">
                        {{'preguntas-colectivo.respuesta.no' | translate}}</div>
                </div>
            </div>

            <div [formGroup]="formTratamientoHospital">
                <div class="form-control">
                    <p class="pregunta">{{'preguntas-colectivo.pregunta.tratado-hospital.causa' | translate}}</p>
                    <input type="text" class="input-preguntas input-form-control" placeholder="Indique la causa"
                        formControlName="causaHospital">
                    <div *ngIf="getFormTrataHospital['causaHospital'].errors" class="content-validacion-form">
                        <div>{{getError(getFormTrataHospital['causaHospital'])}}</div>
                    </div>
                </div>
                <div class="form-control">
                    <p class="pregunta">{{'preguntas-colectivo.pregunta.tratado-hospital.cuando' | translate}}</p>
                    <input type="text" class="input-preguntas input-form-control" placeholder="Indique cuando"
                        formControlName="cuandoHospital">
                    <div *ngIf="getFormTrataHospital['cuandoHospital'].errors" class="content-validacion-form">
                        <div>{{getError(getFormTrataHospital['cuandoHospital'])}}</div>
                    </div>
                </div>
                <div class="form-control">
                    <p class="pregunta">{{'preguntas-colectivo.pregunta.tratado-hospital.exitoso' | translate}}</p>
                    <div class="si-no">
                        <div class="box" [class.selected]="quedoBien === true" (click)="toggleQuedoBien(true)">
                            {{'preguntas-colectivo.respuesta.si' | translate}}</div>
                        <div class="box" [class.selected]="quedoBien === false" (click)="toggleQuedoBien(false)">
                            {{'preguntas-colectivo.respuesta.no' | translate}}</div>
                    </div>
                </div>
            </div>
            <div class="content-validacion-form-general">
                <span>{{mensajeValidacionForm}}</span>
            </div>

            <div class="content-siguiente">
                <app-generic-field-button-next-back class="mr-1" [direccion]="'back'" [texto]="'Atrás'" [estilo]="'border'"
                (eventoClick)="retroceder()">
                </app-generic-field-button-next-back>
                
                <app-generic-field-button-next-back class="siguiente" [direccion]="'next'" [texto]="'Continuar'"
                    [estilo]="'large'" (eventoClick)="preguntaLugarTratado()">
                </app-generic-field-button-next-back>
            </div>
        </ng-container>

        <ng-container *ngIf="isCurrentStep(2)" [formGroup]="formPadeceEnfermedadDefecto">
            <p class="pregunta">{{'preguntas-colectivo.pregunta.padece-enfermedad' | translate}}</p>
            <div class="form-control">
                <div class="si-no">
                    <div class="box" [class.selected]="enfermedad === true" (click)="toggleEnfermedad(true)">
                        {{'preguntas-colectivo.respuesta.si' | translate}}</div>
                    <div class="box" [class.selected]="enfermedad === false" (click)="toggleEnfermedad(false)">
                        {{'preguntas-colectivo.respuesta.no' | translate}}</div>
                </div>
            </div>
            <div>
                <div class="form-control">
                    <p class="pregunta">{{'preguntas-colectivo.pregunta.padece-enfermedad.cual' | translate}}</p>
                    <input type="text" class="input-preguntas input-form-control"
                        placeholder="Indique el nombre de la enfermedad" formControlName="nombreEnfermedad">
                    <div *ngIf="getFormPadeceEnfermedadDefecto['nombreEnfermedad'].errors"
                        class="content-validacion-form">
                        <div>{{getError(getFormPadeceEnfermedadDefecto['nombreEnfermedad'])}}</div>
                    </div>
                </div>

                <div class="content-validacion-form-general">
                    <span>{{mensajeValidacionForm}}</span>
                </div>

            </div>
            <p class="pregunta">{{'preguntas-colectivo.pregunta.padece-defecto' | translate}}</p>
            <div class="form-control">
                <div class="si-no">
                    <div class="box" [class.selected]="defecto === true" (click)="toggleDefectoFisico(true)">
                        {{'preguntas-colectivo.respuesta.si' | translate}}</div>
                    <div class="box" [class.selected]="defecto === false" (click)="toggleDefectoFisico(false)">
                        {{'preguntas-colectivo.respuesta.no' | translate}}</div>
                </div>
            </div>

            <div>
                <div class="form-control">
                    <p class="pregunta">{{'preguntas-colectivo.pregunta.padece-defecto.cual' | translate}}</p>
                    <input type="text" class="input-preguntas input-form-control" placeholder="Indique el defecto"
                        formControlName="defectoDescripcion">
                    <div *ngIf="getFormPadeceEnfermedadDefecto['defectoDescripcion'].errors"
                        class="content-validacion-form" class="content-validacion-form">
                        <div>{{getError(getFormPadeceEnfermedadDefecto['defectoDescripcion'])}}</div>
                    </div>
                </div>

                <div class="content-validacion-form-general">
                    <span>{{mensajeValidacionForm}}</span>
                </div>

            </div>
            <div class="content-siguiente">
                <app-generic-field-button-next-back class="mr-1" [direccion]="'back'" [texto]="'Atrás'" [estilo]="'border'"
                    (eventoClick)="goToPreviousStep()">
                </app-generic-field-button-next-back>
                <app-generic-field-button-next-back class="siguiente" [direccion]="'next'" [texto]="'Continuar'"
                    [estilo]="'large'" (eventoClick)="preguntaQueEnfermedadDefecto()">
                </app-generic-field-button-next-back>
            </div>
        </ng-container>

        <ng-container *ngIf="isCurrentStep(3)" [formGroup]="formEstadoPesoAltura">
            <p class="pregunta" id="queda-menos"
                [innerHTML]="'preguntas-colectivo.falta-poco.estado-salud' | translate"></p>
            <div class="form-control">
                <div class="texto-input">
                    <p class="width-fix">{{'preguntas-colectivo.pregunta.peso' | translate}}</p>
                    <input type="text" class="input-form-control" formControlName="peso" soloNumerosDecimal>
                </div>
                <div *ngIf="getFormEstadoPesoAltura['peso'].invalid && (getFormEstadoPesoAltura['peso'].touched || getFormEstadoPesoAltura['peso'].dirty)  && getFormEstadoPesoAltura['peso'].errors"
                    class="content-validacion-form-general text-center">
                    <div>{{getError(getFormEstadoPesoAltura['peso'])}}</div>
                </div>
            </div>
            <div class="form-control">
                <div class="texto-input ">
                    <p class="width-fix">{{'preguntas-colectivo.pregunta.altura' | translate}}</p>
                    <input type="text" class="input-form-control" formControlName="altura" soloNumerosDecimal>
                </div>
                <div *ngIf="getFormEstadoPesoAltura['altura'].invalid && (getFormEstadoPesoAltura['altura'].touched || getFormEstadoPesoAltura['altura'].dirty)  && getFormEstadoPesoAltura['altura'].errors"
                    class="content-validacion-form-general text-center w-100">
                    <div>{{getError(getFormEstadoPesoAltura['altura'])}}</div>
                </div>
            </div>
            <div class="content-validacion-form-general text-center">
                <span>{{mensajeValidacionForm}}</span>
            </div>

            <div class="content-siguiente">
                <app-generic-field-button-next-back class="mr-1" [direccion]="'back'" [texto]="'Atrás'" [estilo]="'border'"
                    (eventoClick)="goToPreviousStep()">
                </app-generic-field-button-next-back>
                <app-generic-field-button-next-back class="siguiente" [direccion]="'next'" [texto]="'Continuar'"
                    [estilo]="'large'" (eventoClick)="preguntaPesoAltura()">
                </app-generic-field-button-next-back>
            </div>
        </ng-container>

        <ng-container *ngIf="isCurrentStep(4)" [formGroup]="formTensionNormalMotocicleta">
            <p class="pregunta">{{'preguntas-colectivo.pregunta.tension' | translate}}</p>
            <div class="form-control">
                <div class="si-no">
                    <div class="box" [class.selected]="tensionNormal === true" (click)="toggleTensionNormal(true)">
                        {{'preguntas-colectivo.respuesta.si' | translate}}</div>
                    <div class="box" [class.selected]="tensionNormal === false" (click)="toggleTensionNormal(false)">
                        {{'preguntas-colectivo.respuesta.no' | translate}}</div>
                </div>
            </div>
        
            <div class="contenedor-inputs">
                <div class="texto-input">
                    <p>{{'preguntas-colectivo.pregunta.tension.maxima' | translate}}</p>
                    <input type="text" class="input-form-control" formControlName="tensionMaxima" soloNumerosDecimal>
                </div>
                <div class="texto-input">
                    <p>{{'preguntas-colectivo.pregunta.tension.minima' | translate}}</p>
                    <input type="text" class="input-form-control" formControlName="tensionMinima" soloNumerosDecimal>
                </div>
            </div>
            <div *ngIf="getFormTensionNormalMotocicleta['tensionMaxima'].invalid && (getFormTensionNormalMotocicleta['tensionMaxima'].touched || getFormTensionNormalMotocicleta['tensionMaxima'].dirty) && getFormTensionNormalMotocicleta['tensionMaxima'].errors"
                class="content-validacion-form-general">
                {{getError(getFormTensionNormalMotocicleta['tensionMaxima'])}}
            </div>
            <div *ngIf="getFormTensionNormalMotocicleta['tensionMinima'].invalid && (getFormTensionNormalMotocicleta['tensionMinima'].touched || getFormTensionNormalMotocicleta['tensionMinima'].dirty) && getFormTensionNormalMotocicleta['tensionMinima'].errors"
                class="content-validacion-form-general">
                {{getError(getFormTensionNormalMotocicleta['tensionMinima'])}}
            </div>
            <div *ngIf="getFormTensionNormalMotocicleta['tensionMaxima'].errors?.['tensionMinimaMayorQueMaxima'] || getFormTensionNormalMotocicleta['tensionMinima'].errors?.['tensionMinimaMayorQueMaxima']"
                class="content-validacion-form-general">
                {{ 'preguntas-colectivo.form.tensionValida' | translate }}
            </div>
        
            <p class="pregunta">{{'preguntas-colectivo.pregunta.conduce-motocicleta' | translate}}</p>
            <div class="form-control">
                <div class="si-no">
                    <div class="box" [class.selected]="conduceMotocicleta === true" (click)="toggleConduceMotocicleta(true)">
                        {{'preguntas-colectivo.respuesta.si' | translate}}
                    </div>
                    <div class="box" [class.selected]="conduceMotocicleta === false" (click)="toggleConduceMotocicleta(false)">
                        {{'preguntas-colectivo.respuesta.no' | translate}}
                    </div>
                </div>
            </div>
        
            <div class="texto-input" id="cilindrada">
                <p>{{'preguntas-colectivo.pregunta.conduce-motocicleta.cilindrada' | translate}}</p>
                <input type="text" formControlName="cilindrada" class="input-form-control" soloNumerosEnterosPositivos>
            </div>
            <div *ngIf="getFormTensionNormalMotocicleta['cilindrada'].invalid && (getFormTensionNormalMotocicleta['cilindrada'].touched || getFormTensionNormalMotocicleta['cilindrada'].dirty) && getFormTensionNormalMotocicleta['cilindrada'].errors"
                class="content-validacion-form-general">
                <div>{{getError(getFormTensionNormalMotocicleta['cilindrada'])}}</div>
            </div>
            <div class="content-siguiente">
                <app-generic-field-button-next-back class="mr-1" [direccion]="'back'" [texto]="'Atrás'" [estilo]="'border'"
                    (eventoClick)="goToPreviousStep()">
                </app-generic-field-button-next-back>
                <app-generic-field-button-next-back class="siguiente" [direccion]="'next'" [texto]="'Continuar'"
                    [estilo]="'large'" (eventoClick)="preguntaTensionNormalMotocicleta()">
                </app-generic-field-button-next-back>
            </div>
        </ng-container>
        

        <ng-container *ngIf="isCurrentStep(5)" [formGroup]="formPracticaDeporte">
            <p class="pregunta">{{'preguntas-colectivo.pregunta.deporte' | translate}}</p>
            <div class="form-control">
                <div class="si-no">
                    <div class="box" [class.selected]="practicaDeporte === true" (click)="togglePracticaDeporte(true)">
                        {{'preguntas-colectivo.respuesta.si' | translate}}</div>
                    <div class="box" [class.selected]="practicaDeporte === false"
                        (click)="togglePracticaDeporte(false)">{{'preguntas-colectivo.respuesta.no' | translate}}</div>
                </div>
            </div>

            <div>
                <div class="form-control">
                    <p class="pregunta">{{'preguntas-colectivo.pregunta.deporte.cual' | translate}}</p>
                    <input type="text" class="input-preguntas input-form-control" placeholder="Indique el deporte"
                        formControlName="deporte">
                    <div *ngIf="getFormPracticaDeporte['deporte'].errors" class="content-validacion-form">
                        <div>{{getError(getFormPracticaDeporte['deporte'])}}</div>
                    </div>
                </div>

            </div>
            <div class="content-validacion-form-general text-center">
                <span>{{mensajeValidacionForm}}</span>
            </div>
            <div class="content-siguiente">
                <app-generic-field-button-next-back class="mr-1" [direccion]="'back'" [texto]="'Atrás'" [estilo]="'border'"
                    (eventoClick)="goToPreviousStep()">
                </app-generic-field-button-next-back>
                <app-generic-field-button-next-back class="siguiente" [direccion]="'next'" [texto]="'Finalizar'"
                    [estilo]="'large'" (eventoClick)="preguntaDeporte()">
                </app-generic-field-button-next-back>
            </div>
        </ng-container>
    </div>
</div>